module.exports = __webpack_public_path__ + "static/media/image3.1d508d2c.jpg";